import { handleActions } from 'redux-actions';

import {
  trialBalanceTaggedElementsLoading,
  trialBalanceTaggedElementsLoaded,
  trialBalanceTaggedElementsError,
} from 'store/actions/trial-balance/tagged-element-action';
import TrialBalanceTaggedElements from 'models/api/trial-balance/tagged-elements-api-model';

export default handleActions(
  {
    [trialBalanceTaggedElementsLoading]: (trialBalanceTaggedElements) => {
      return trialBalanceTaggedElements.setLoading();
    },
    [trialBalanceTaggedElementsLoaded]: (
      trialBalanceTaggedElements,
      { payload },
    ) => {
      return trialBalanceTaggedElements.setLoaded(payload);
    },
    [trialBalanceTaggedElementsError]: (
      trialBalanceTaggedElements,
      { payload },
    ) => {
      return trialBalanceTaggedElements.setError(payload);
    },
  },
  new TrialBalanceTaggedElements(),
);
